export default {
    methods: {
        scrollToTop: function() {
            window.scrollTo(0, 0);
        },
        isIe() {
            return (
                (!!window.MSInputMethodContext && !!document.documentMode) ||
                window.navigator.userAgent.indexOf('MSIE') != -1
            );
        }
    }
};
